// ABOUTME: Composes the actions of a model-selection product card into a single component.
// ABOUTME: Renders the phase-out badge, the attachments info button, the detail page button and the optional favorite star.

import type { IProduct } from '@coolshop/cool-model-selection';
import { Box } from '@ds/coolshop';

import { ProductAttachmentsAction } from './ProductAttachmentsAction';
import { ProductDetailPageAction } from './ProductDetailPageAction';
import { ProductFavoriteAction } from './ProductFavoriteAction';
import { SoonAvailabilityBadge } from './SoonAvailabilityBadge';

/**
 * Every host-rendered action of a catalog card goes through this composition, rendered by
 * `ProductCardContent`. Each child decides on its own whether it has anything to render.
 */
export function ProductCardStartActions(product: IProduct & { showFavorite?: boolean }) {
    const { showFavorite } = product;
    return (
        <Box display="flex" alignItems="center" gap={0.5}>
            <SoonAvailabilityBadge {...product} />
            <ProductAttachmentsAction {...product} />
            <ProductDetailPageAction {...product} />
            {showFavorite && <ProductFavoriteAction {...product} />}
        </Box>
    );
}
